






























































	import { Component, Vue } from 'vue-property-decorator';
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import Banner from '@/components/banner/index.vue';
    import { EventBus } from '@/utils/eventBus.js';
    
	//
	const YOUPAI = 'https://appd.knowbox.cn/ss/activity/knowbox-web/img/';

	@Component({
		components: {
            swiper,
            swiperSlide, 
			Banner
		}
	})
	export default class Index extends Vue {
        public $refs!: {
			swiper: any;
		};
		private swiperOption: any = {
            loop: true,
            // autoplay: {
            //     delay: 2500,
            //     disableOnInteraction: false
            // },
			pagination: {
                el: '.swiper-pagination',
                clickable: true
			}
		};

		private get swiper() {
			return this.$refs.swiper.swiper;
        }

		private schoolAssistList: any = [
			{
                id: 'teacher',
				icon: `${YOUPAI}teacher-app.png`,
                name: '小盒老师',
                query: 'block=teacher'
			},
			{
                id: 'student',
				icon: `${YOUPAI}student-app.png`,
                name: '小盒学生',
                query: 'block=student'
			},
			// {
            //     id: 'family-school',
			// 	icon: `${YOUPAI}family-school-app.png`,
			// 	name: '家校盒子'
			// },
			// {
            //     id: 'xiaoxiangshuju',
			// 	icon: `${YOUPAI}xiaoxiangshuju-web.png`,
			// 	name: '小盒数据'
			// }
		];
		private familyAssistList: any = [
			{
                id: 'parent',
				icon: `${YOUPAI}parent-app.png`,
                name: '小盒家长',
                query: 'block=parent'
			},
			{
                id: 'aiclass',
				icon: `${YOUPAI}aiclass-app.png`,
				name: '小盒课堂',
                url: 'https://xiaoheketang.knowbox.cn'
			},
			// {
            //     id: 'program',
			// 	icon: `${YOUPAI}program-app.png`,
			// 	name: '小象编程',
            //     url: 'https://code.knowbox.cn'
			// },
			// {
            //     id: 'english',
			// 	icon: `${YOUPAI}english-app.png`,
			// 	name: '小象英语',
            //     query: 'block=english'
			// },
			// {
            //     id: 'science',
			// 	icon: `${YOUPAI}science-app.png`,
			// 	name: '小象科学',
            //     query: 'block=science'
			// },
			// {
            //     id: 'ocr',
			// 	icon: `${YOUPAI}ocr-app.png`,
			// 	name: '拍作业',
            //     query: 'block=ocr'
			// },
			{
                id: 'plus',
				icon: `${YOUPAI}plus.png`,
				name: ''
			}
        ];
        private mouseenter(e: any) {}

        private mouseleave(e: any) {}

        private handleClick(item: any) {
            if (item.id !== 'aiclass' && item.id !== 'program') {
                this.$router.push({
                    path: `/product${item.query ? '?' + item.query : ''}`
                });

                EventBus.$emit('router.change', '/product');
            } else {
                window.open(item.url);
            }
        }

        private jump(news: any) {
            this.$router.push({
                path: `/news/${news.news_id}`
            });
        }

        private get newsInfo() {
            return this.$store.state.common.newsHome;
        }
	}
